var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type === 'sqm')?_c('span',{staticClass:"result-sqm"},[_c('span',{staticClass:"text"},[_c('b',[_vm._v(_vm._s(_vm.totalSpace))]),_vm._v(" "+_vm._s(_vm.$t('sqm'))+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }